ALLOWED_CONTROLLER = 'answering_service'
ALLOWED_ACTIONS = ['card_authorized']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  stop_video = ->
    $('#video-stream').writeAttribute('src', '/video_timed_out.html')

  video_stream_timeout = setTimeout(stop_video, 300000)


$(document).ready(ready)
$(document).on('turbo:load', ready)
